import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import Alert from '@amzn/meridian/alert';
import { SeeMoreOnAmazonButton } from 'src/common/buttons/seeMoreOnAmazonButton';
import { AdBlock } from 'src/common/adBlock/AdBlock';
import { ProductCard } from 'src/common/productCard';
import { DogPage } from 'src/common/errors';
import { Paragraph } from 'src/common/styled';
import { usePageContext } from 'src/hooks';
import { CreatorProfileCard } from '../components/CreatorProfileCard';
import { CreatorVideo } from '../components/CreatorVideo';
import { HeroImage } from '../components/styled';
import styled from '@emotion/styled';
import { ContentType } from '@amzn/handshake-painter-typescript-client/v1';
const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 12px;
  gap: 12px;
`;
const Container = styled.div `
  background: ${({ theme }) => theme.rio.semantic.color.background.secondary};
  border-radius: 8px;
  overflow: hidden;
  padding: 8px;
`;
const sortProducts = (products) => {
    const copyProducts = [...products];
    return copyProducts.sort((a, b) => {
        if (a.buyable && !b.buyable)
            return -1;
        if (!a.buyable && b.buyable)
            return 1;
        return 0;
    });
};
export const CreatorStorefrontPage = () => {
    const { creatorData, bundle } = usePageContext();
    const { data, isError } = creatorData;
    // Handle error state
    if (isError || !data) {
        return _jsx(DogPage, {});
    }
    const hasProducts = data.products && data.products.length > 0;
    const isVideoContent = data.contentType === ContentType.Video;
    return (_jsxs(_Fragment, { children: [_jsx(CreatorProfileCard, { avatarUrl: data.creatorAvatarUrl, name: data.creatorName, isTopCreator: data.isTopCreator, creatorBadges: data.creatorBadges }), isVideoContent ? (_jsx(Row, { minHeight: "MIN(calc(100vh - 200px), 110vw)", children: _jsx(CreatorVideo, { contentId: data.aci, videoRequestId: data.aci, src: data.contentData.contentUrl }) })) : (_jsx(Row, { minHeight: "MIN(calc(100vh - 200px), 110vw)", children: _jsx(HeroImage, { src: data.contentData.contentUrl, alt: `${data.creatorName} content`, "data-testid": "creator-image" }) })), _jsx(Row, { spacingInset: "400 350", children: _jsx(Paragraph, { type: "b200", children: data.contentMessage }) }), hasProducts ? (_jsxs(_Fragment, { children: [_jsx(Row, { spacingInset: "none 350", children: isVideoContent ? (_jsx(Text, { type: "h200", children: bundle.getMessage('productsInThisVideo') })) : (_jsx(Text, { type: "h200", children: bundle.getMessage('productsInThisPhoto') })) }), _jsx(Grid, { "data-testid": "storefront-product-list", children: sortProducts(data.products).map((productItem) => (_jsx(Container, { children: _jsx(ProductCard, { productItem: productItem, isStorefront: true }) }, productItem.asin))) })] })) : (_jsxs(Column, { spacingInset: "350", spacing: "400", children: [_jsxs(Alert, { type: "error", "data-testid": "product-list-alert", children: [_jsx(Text, { type: "b200", children: _jsx("b", { children: bundle.getMessage('unableToDisplayProducts') }) }), _jsx(Text, { type: "b200", children: bundle.getMessage('tryAgainLater') })] }), _jsx(SeeMoreOnAmazonButton, { offRampUrl: data.viewOnAmazonUrl })] })), _jsx(AdBlock, { offRampUrl: data.viewOnAmazonUrl })] }));
};
